<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Guest Messaging'"
      [canGoBack]="true"
      [customBack]="fromGettingStarted ? 'getting-started' : null" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (!loaded) {
      <div class="loading-container">
        <tidy-loader />
      </div>
    }
    @if (loaded) {
      <tidy-button
        [text]="'Complete Step'"
        [action]="completeStep"
        class="primary" />
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
} @else {
  <ng-container *ngTemplateOutlet="content" />
}
